export { I18nEsPeModule } from './i18n-es-pe.module';
export * from './es-PE';
